import React, { useState, useEffect } from 'react'
import {
  Col,
  Row,
  Spin,
  message,
  Modal,
  Button,
  Form,
  Input,
  Select
} from 'antd'
import ds from '../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  isEmptyObject,
  checkRightspermissions,
  checkScreenAccess,
  checkPasswordStrength
} from '../appRedux/actions/GlobalMethods'
import { setCommonConfigs } from '../appRedux/actions/CommonData'
import {
  // REACT_APP_BUS_SITE_SECOND,
  Options,
  PAY_PAY_MODE,
  STORE_REQ_TYPES
} from '../constants/StoreSetting'
import PaymentTypesModal from './Payments/PaymentTypesModal'
import PaymentStatusModal from './Payments/PaymentStatusModal'
import CheckLoginCredentials from './CheckLoginCredentials'
import { env } from '../env'

const { REACT_APP_BUS_SITE_SECOND } = env

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const pageLevels = 4

const StoreRequest = props => {
  const { noOfOutlet, noOfReg, id, periodFreq } = props.match.params
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const history = useHistory()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [pageStatus, setPageStatus] = useState(1)
  const [businessObjects, setBusinessObjects] = React.useState([
    { id: 1, label: 'Default' }
  ])
  const [countriesObject, setcountriesObject] = React.useState([
    { id: 1, label: 'Default' }
  ])
  const [currencyObject, setcurrencyObject] = React.useState([
    { id: 1, label: 'Default' }
  ])
  const [storeUrlStatus, storeUrlStatusState] = React.useState({
    storeUrlStatus: '2' //2  - (Nothing , on page load)
  })
  const [getIsEmailAllowed, setIsEmailAllowed] = React.useState(0) //0:Empty Email, 1:Validating ,2: Validated, 3: Not Valid
  const [isLoader, setIsLoader] = React.useState(false)
  const [postObject, setPostObject] = React.useState({
    businessTypeID: 0,
    userFirstName: '',
    userMiddleName: '',
    userLastName: '',
    nbrOfLocation: '',
    turnoverAnnual: '',
    // agreement: values.agreement,
    emailAddress: '',
    password: '',
    contactNumber: '',
    storeName: '',
    storeUrl: '',
    countryID: 0,
    currencyID: 0,
    userName: '',
    callType: 0
  })
  const [passwordStatus, setPasswordState] = React.useState('1')
  const [infoGathered, setInfoGathered] = React.useState(false)
  const [storeReqID, setStoreReqID] = React.useState('')
  const [visible, setVisible] = React.useState(false)

  //for common data -> store currency
  //const DeleteContext = createContext();
  useEffect(() => {
    let mounted = true
    if (mounted) {
      getRegistrationData()
      // dispatch(setCommonConfigs(HOME))
    }

    return () => (mounted = false)
  }, [])

  // React.useEffect(() => {
  //   let mounted = true
  //   if (mounted) {
  //     const commonData = getReduxCommonSetting
  //     const respData =
  //       commonData &&
  //       commonData.storeCommonConfigs &&
  //       commonData.storeCommonConfigs.storeConfig
  //         ? commonData.storeCommonConfigs.storeConfig
  //         : {}
  //     if (respData && respData.currencyData) {
  //       let currencyData = respData.currencyData
  //       setCurrData(currencyData)
  //     }
  //     // rights && permissions
  //     if (commonData && commonData.storeCommonConfigs) {
  //       const rpData = checkRightspermissions(commonData)
  //       if (rpData && !isEmptyObject(rpData)) {
  //         setupRightsPermissions(rpData)
  //         setAccessLoading(false)
  //       } else {
  //         toInitialState()
  //         setAccessLoading(false)
  //       }
  //     }
  //   }

  //   return () => (mounted = false)
  // }, [getReduxCommonSetting])

  // function toInitialState () {
  //   setRights([])
  //   setPermissions([])
  //   setIsAllowRead(false)
  //   setIsDisableCreate(true)
  //   setIsDisableUpdate(true)
  //   setIsDisableDelete(true)
  //   setAccessLoading(true)
  // }

  // function setupRightsPermissions (rpData) {
  //   if (rpData.rights && rpData.rights.length > 0) {
  //     setRights(rpData.rights)
  //   } else {
  //     setRights([])
  //   }
  //   if (rpData.permissions && rpData.permissions.length > 0) {
  //     setPermissions(rpData.permissions)
  //   } else {
  //     setPermissions([])
  //   }
  //   if (rpData.read) {
  //     setIsAllowRead(true)
  //   } else {
  //     setIsAllowRead(false)
  //   }
  //   if (rpData.create) {
  //     setIsDisableCreate(false)
  //   } else {
  //     setIsDisableCreate(true)
  //   }
  //   if (rpData.update) {
  //     setIsDisableUpdate(false)
  //   } else {
  //     setIsDisableUpdate(true)
  //   }
  //   if (rpData.delete) {
  //     setIsDisableDelete(false)
  //   } else {
  //     setIsDisableDelete(true)
  //   }
  // }

  const onFinish = values => {
    if (
      countriesObject &&
      businessObjects &&
      currencyObject &&
      countriesObject.length > 1 &&
      businessObjects.length > 1 &&
      currencyObject.length > 1
    ) {
      let postObj = postObject
      postObj.callType = STORE_REQ_TYPES.SUBSCRIPTION_REQ
      postObj.businessTypeID = values.businessType
        ? values.businessType
        : postObject.businessTypeID
      postObj.userFirstName = values.firstName
        ? values.firstName
        : postObject.userFirstName
      postObj.userLastName = values.lastName
        ? values.lastName
        : postObject.userLastName
      postObj.nbrOfLocation = values.locations
        ? values.locations
        : postObject.nbrOfLocation
      postObj.turnoverAnnual = values.annualTurnOver
        ? values.annualTurnOver
        : postObject.turnoverAnnual
      postObj.emailAddress = values.email
        ? values.email
        : postObject.emailAddress
      postObj.password = values.password ? values.password : postObject.password
      postObj.contactNumber = values.Phone
        ? values.Phone
        : postObject.contactNumber
      postObj.storeName = values.storeName
        ? values.storeName
        : postObject.storeName
      postObj.storeUrl = values.storeUrl
        ? values.storeUrl.split('.')[0]
        : postObject.storeUrl
      postObj.countryID = values.countryID
        ? values.countryID
        : postObject.countryID
      postObj.currencyID = values.currencyID
        ? values.currencyID
        : postObject.currencyID
      postObj.userName = values.email ? values.email : postObject.emailAddress
      postObj.IsMonthly = periodFreq == 1
      postObj.PackageID = id
      postObj.NoOfOutlet = noOfOutlet
      postObj.NoOfRegisters = noOfReg
      setPostObject(postObj)
      if (pageStatus == pageLevels) {
        if (
          storeUrlStatus.storeUrlStatus === '0' ||
          storeUrlStatus.storeUrlStatus === '4' ||
          storeUrlStatus.storeUrlStatus === '5'
        ) {
          message.error('First you need to enter valid Store URL')
        } else {
          if (getIsEmailAllowed == 2) {
            callService(postObj)
          } else {
            message.error('First you need to enter valid Email')
          }
        }
      } else {
        let allow = true
        if (pageStatus == 2) {
          // for email part
          if (getIsEmailAllowed != 2) {
            message.error('First you need to enter valid Email')
            allow = false
          }
        } else if (pageStatus == 3) {
          // for store url, store name part
          if (
            storeUrlStatus.storeUrlStatus === '0' ||
            storeUrlStatus.storeUrlStatus === '4' ||
            storeUrlStatus.storeUrlStatus === '5'
          ) {
            message.error('First you need to enter valid Store URL')
            allow = false
          }
        }
        if (allow) {
          setPageStatus(pageStatus + 1)
        }
      }
    } else {
      message.error('Kindly refresh the page or check internet connection', 4)
    }
  }

  function onPassChange (e) {
    const result = checkPasswordStrength(e.target.value)
    setPasswordState(result)
  }

  function changeVisible () {
    setVisible(false)
  }

  async function callService (values) {
    setIsLoader(true)
    let registerUser = {
      data: {
        msgCode: '',
        msgDescription: ''
      }
    }
    await ds
      .storeCallReqService(values)
      .then(response => {
        setIsLoader(false)
        registerUser.data = response.data
      })
      .catch(e => {
        setIsLoader(false)
        message.error("Something isn't right")
        //console.log('Catch', e)
      })

    if (registerUser.data.msgCode == 'GENERAL_SUCCESS') {
      setInfoGathered(true)
      setVisible(true)
      if (registerUser.data.data && registerUser.data.data > 0) {
        setStoreReqID(registerUser.data.data)
      }
    }
    if (registerUser.data.msgCode == 'GENERAL_ERROR') {
      message.error(registerUser.data.msgDescription)
    } else if (registerUser.data.msgCode == 'REG_FIELD_NOT_VALID') {
      message.error(registerUser.data.msgDescription, 5)
    }
    if (registerUser.data.msgCode == 'REGISTRATION_NOT_ACTIVE') {
      message.error(registerUser.data.msgDescription)
    }
  }

  function emailChange (evt) {
    let email = evt.target.value.split('.')[0]
    if (email != '') {
      let reg = new RegExp('[a-z0-9]+@[a-z]+.[a-z]{2,3}')
      if (reg.test(email)) {
        emailVerification()
      } else {
        message.error('Please enter valid email')
      }
    }
  }

  async function getRegistrationData () {
    const getRegistrationData = ds.getRegistrationData()
    await getRegistrationData.then(response => {
      setcountriesObject(response.data.data.countriesOptions)
      setcurrencyObject(response.data.data.currencyOptions)
      setBusinessObjects(response.data.data.businessOptions)
    })
  }

  async function storeURLVerificationService () {
    //1 -Success (Url AVAILABLE)
    //0 -error (URL TAKEN)
    //2  - (Nothing , on page load)
    //3 -validatiing (Url validiting start)
    let storeJson = {
      storeURL: form.getFieldValue('storeUrl')
    }
    storeJson = { storeURL: storeJson.storeURL.split('.')[0] }
    let storeResult = {
      data: {
        msgCode: '',
        msgDescription: ''
      }
    }
    const storeUrlVerification = ds.storeURLVerification(storeJson)
    await storeUrlVerification.then(
      response => (storeResult.data = response.data)
    )

    if (storeResult.data.msgCode === 'URL_AVAILABLE') {
      storeUrlStatusState({ storeUrlStatus: '1' })
    } else if (storeResult.data.msgCode === 'URL_NOT_AVAILABLE') {
      storeUrlStatusState({ storeUrlStatus: '0' })
    } else if (storeResult.data.msgCode === 'STORE_NAME_LENGTH') {
      storeUrlStatusState({ storeUrlStatus: '5' })
    }
  }
  async function emailVerification () {
    let storeJson = { email: form.getFieldValue('email') }
    let storeResult = {
      data: {
        data: '',
        msgCode: '',
        msgDescription: ''
      }
    }
    const emailVerification = ds.emailDomainVerification(storeJson)
    await emailVerification.then(response => (storeResult.data = response.data))
    if (storeResult.data.data) {
      if (storeResult.data.msgCode === 'EMAIL_DOMAIN_ALLOWED') {
        setIsEmailAllowed(2)
      } else if (storeResult.data.msgCode === 'EMAIL_DOMAIN_NOT_ALLOWED') {
        setIsEmailAllowed(3)
      } else {
        setIsEmailAllowed(3)
      }
    } else {
      setIsEmailAllowed(3)
    }
  }

  function sNameChange (evt) {
    let sUrl = evt.target.value.replace(/[^a-zA-Z0-9]/g, '')
    form.setFieldsValue({ storeUrl: sUrl.toLowerCase() + REACT_APP_BUS_SITE_SECOND })
    storeUrlStatusState({ storeUrlStatus: '3' })
    storeURLVerificationService()
  }

  function sUrlChange (evt) {
    let sUrl = evt.target.value.split('.')[0]
    let reg = new RegExp('^[a-zA-Z0-9_.]*$')
    if (reg.test(sUrl)) {
      form.setFieldsValue({ storeUrl: sUrl + REACT_APP_BUS_SITE_SECOND })
      storeUrlStatusState({ storeUrlStatus: '3' })
      storeURLVerificationService()
    } else {
      storeUrlStatusState({ storeUrlStatus: '4' })
      message.error('Space & Special Characters are not allowed')
    }
  }

  return (
    <div id='main' className='Signin Signin-wizard-bg'>
      <CheckLoginCredentials />
      <Row>
      <Col lg={24} md={24} sm={24} xs={24}>
          {!infoGathered ? (
            <Modal
            className='Free-Reg-Form-Modal'
              title={
                <Row>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <h2 className='mb-0'> Get access to our full point of sale system</h2>
                    <p className='mb-0'> Plus heaps more great online resources </p>
                  </Col>
                </Row>
              }
              centered
              visible={true}
              closable={false}
              width={750}
              footer={
                <>
                <Form
                className=''
                      {...formItemLayout}
                      form={form}
                      name='register'
                      onFinish={onFinish}
                      // onFinishFailed={onFinishFailed}
                      initialValues={{
                        prefix: '86'
                      }}
                      scrollToFirstError
                    >

                          <Form.Item className='m-0'>
                            <Button
                              className='btn-signin btn-reversed'
                              type='primary'
                              htmlType='submit'
                              size='large'
                              name='register'
                              loading={isLoader}
                            >
                              {pageStatus == pageLevels
                                ? 'Pay to Subscribe'
                                : 'Continue'}
                            </Button>
                          </Form.Item>
                          </Form>
                          </>
              }
              // onCancel={() => dispatch(loadIsDayPast(false))}
            >
              <Spin
                tip={'We are setting up store for you'}
                // tip={<IntlMessages id='sell.cashlisting.cashloading' />}
                spinning={isLoader}
                size='large'
              >
                
                    <Form
                      {...formItemLayout}
                      form={form}
                      name='register'
                      onFinish={onFinish}
                      // onFinishFailed={onFinishFailed}
                      initialValues={{
                        prefix: '86'
                      }}
                      scrollToFirstError
                    >
                      {pageStatus == 1 && (
                        <Row>
                          <Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                           
                              <Form.Item
                                className='ant-form-item-label-custom'
                                name={`firstName`}
                                label={'First Name'}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Required'
                                  }
                                ]}
                              >
                                <Input placeholder='First Name' size='large' />
                              </Form.Item>
                         
                          </Col>
                          <Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                              <Form.Item
                                className='ant-form-item-label-custom'
                                name={`lastName`}
                                label={'Last Name'}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Required'
                                  }
                                ]}
                              >
                                <Input placeholder='Last Name' size='large' />
                              </Form.Item>
                            
                          </Col>
                        </Row>
                      )}

                      {pageStatus == 2 && (
                        <Row>

                        <Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                              <Form.Item
                                className='ant-form-item-label-custom'
                                name='email'
                                label='Email'
                                rules={[
                                  {
                                    type: 'email',
                                    message:
                                      'Please enter a valid email address.'
                                  },
                                  {
                                    required: true,
                                    message: 'Please enter your email address.'
                                  }
                                ]}
                                {...{
                                  help:
                                    getIsEmailAllowed === 0
                                      ? ''
                                      : getIsEmailAllowed === 1
                                      ? 'validating'
                                      : getIsEmailAllowed === 2
                                      ? 'Email Valid'
                                      : 'Email not valid',
                                  hasFeedback: true,
                                  validateStatus:
                                    getIsEmailAllowed === 0
                                      ? ''
                                      : getIsEmailAllowed === 1
                                      ? 'validating'
                                      : getIsEmailAllowed === 2
                                      ? 'success'
                                      : 'error'
                                }}
                              >
                                <Input
                                  placeholder='Your email address'
                                  size='large'
                                  onBlur={emailChange}
                                />
                              </Form.Item>
                          
                          </Col>

                        <Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                              <Form.Item
                                className='ant-form-item-label-custom'
                                name={`Phone`}
                                label={'phone'}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Required'
                                  }
                                ]}
                              >
                                <Input
                                  placeholder='Your Phone Number'
                                  size='large'
                                />
                              </Form.Item>
                           
                          </Col>
                        </Row>
                      )}

                      {pageStatus == 3 && (
                        <>
                          <Row>

<Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>

                                <Form.Item
                                  className='ant-form-item-label-custom'
                                  name={`storeName`}
                                  label={'Store Name'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Required'
                                    }
                                  ]}
                                >
                                  <Input
                                    placeholder='Your Store Name'
                                    size='large'
                                    onChange={sNameChange}
                                  />
                                </Form.Item>
                            
                            </Col>

                           <Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                              <Form.Item
                                className='ant-form-item-label-custom'
                                name='storeUrl'
                                label='Store URL'
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter your store name.'
                                  }
                                ]}
                                {...{
                                  help:
                                    storeUrlStatus.storeUrlStatus === '2'
                                      ? ' '
                                      : storeUrlStatus.storeUrlStatus === '3'
                                      ? 'Validating'
                                      : storeUrlStatus.storeUrlStatus === '1'
                                      ? ''
                                      : storeUrlStatus.storeUrlStatus === '4'
                                      ? 'Space & Special Characters are not allowed'
                                      : storeUrlStatus.storeUrlStatus === '5'
                                      ? 'Store name min length is 4 max Length is 32'
                                      : 'This web address is unavailable',
                                  hasFeedback: true,
                                  validateStatus:
                                    storeUrlStatus.storeUrlStatus === '2'
                                      ? ''
                                      : storeUrlStatus.storeUrlStatus === '3'
                                      ? 'validating'
                                      : storeUrlStatus.storeUrlStatus === '1'
                                      ? 'success'
                                      : 'error'
                                }}
                              >
                                <Input
                                  placeholder={`yourstore${REACT_APP_BUS_SITE_SECOND}`}
                                  onChange={sUrlChange}
                                />
                              </Form.Item>
                            </Col>
                          </Row>

                          <Row>

<Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>

                                <Form.Item
                                  className='ant-form-item-label-custom'
                                  name={`businessType`}
                                  label={'Type of Business'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Required'
                                    }
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    optionFilterProp='children'
                                    placeholder='Choose a retail category'
                                  >
                                    {businessObjects &&
                                      businessObjects.map((e, key) => {
                                        return (
                                          <option key={key} value={e.id}>
                                            {e.label}
                                          </option>
                                        )
                                      })}
                                  </Select>
                                </Form.Item>
                              
                            </Col>

                           

<Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                                <Form.Item
                                  className='ant-form-item-label-custom'
                                  name={`locations`}
                                  label={'Number of Locations'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Required'
                                    }
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    optionFilterProp='children'
                                    placeholder='Choose how many locations you have'
                                  >
                                    {Options.LocationOptions &&
                                      Options.LocationOptions.map((e, key) => {
                                        return (
                                          <option key={key} value={e.label}>
                                            {e.label}
                                          </option>
                                        )
                                      })}
                                  </Select>
                                </Form.Item>
                              
                            </Col>
                          </Row>

                          <Row>

<Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>

                                <Form.Item
                                  className='ant-form-item-label-custom'
                                  name={`annualTurnOver`}
                                  label={'Estimated Annual Turnover'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Required'
                                    }
                                  ]}
                                >
                                  <Select
                                    placeholder='Choose an annual turn over range'
                                    showSearch
                                    optionFilterProp='children'
                                  >
                                    {Options.TurnOverOptions &&
                                      Options.TurnOverOptions.map((e, key) => {
                                        return (
                                          <option key={key} value={e.label}>
                                            {e.label}
                                          </option>
                                        )
                                      })}
                                  </Select>
                                </Form.Item>
                              
                            </Col>
                          </Row>
                        </>
                      )}

                      {pageStatus == 4 && (
                        <>
                           <Row>

<Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>

                                <Form.Item
                                  className='ant-form-item-label-custom ant-form-margin-right'
                                  name='countryID'
                                  label='Country'
                                  hasFeedback
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Select your country'
                                    }
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    optionFilterProp='children'
                                    placeholder='Select Country'
                                  >
                                    {countriesObject &&
                                      countriesObject.map((e, key) => {
                                        return (
                                          <option key={key} value={e.id}>
                                            {e.label}
                                          </option>
                                        )
                                      })}
                                  </Select>
                                </Form.Item>
                             
                            </Col>

                           

<Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                                <Form.Item
                                  className='ant-form-item-label-custom'
                                  name='currencyID'
                                  label='Currency'
                                  hasFeedback
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Select your Currency'
                                    }
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    optionFilterProp='children'
                                    placeholder='Select Currency'
                                  >
                                    {currencyObject &&
                                      currencyObject.map((e, key) => {
                                        return (
                                          <option key={key} value={e.id}>
                                            {e.label}
                                          </option>
                                        )
                                      })}
                                  </Select>
                                </Form.Item>
                             
                            </Col>
                          </Row>

                          <Row>

<Col lg={12} md={12} sm={24} xs={24} className='form-inner-pad-0'>
                            <Form.Item
                              className='ant-form-item-label-custom password-fix'
                              name='password'
                              label='Password'
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter a password.'
                                }
                              ]}
                              {...{
                                help:
                                  passwordStatus === '1'
                                    ? ' '
                                    : passwordStatus === '2'
                                    ? 'Minimum length should be 8 characters'
                                    : passwordStatus === '3'
                                    ? 'At least 1 small case character required'
                                    : passwordStatus === '4'
                                    ? 'At least 1 upper case character required'
                                    : passwordStatus === '5'
                                    ? 'At least 1 special character required'
                                    : passwordStatus == '6'
                                    ? 'At least 1 numeric value'
                                    : passwordStatus == '7'
                                    ? 'Space Not Allowed In Password'
                                    : 'Validating',
                                hasFeedback: true,
                                validateStatus:
                                  passwordStatus === '1' ? 'success' : 'error'
                              }}
                            >
                              <Input.Password
                                placeholder='Choose a password'
                                onChange={onPassChange}
                              />
                            </Form.Item>
                            </Col>

                          </Row>
                        </>
                      )}

                       <Row>

<Col lg={24} md={24} sm={24} xs={24} className='form-inner-pad-0 text-right'>


                        </Col>
                      </Row>
                    </Form>
                
              </Spin>
            </Modal>
          ) : (
            <>
              <PaymentStatusModal />
              <PaymentTypesModal
                mode={PAY_PAY_MODE.REGISTRATION_SUBSCRIPTION} // 3 for REGISTRATION
                storeReqID={storeReqID}
                visible_reg={visible}
                cancelShow={changeVisible}
              />
            </>
          )}
        </Col>
      </Row>
    </div>
  )
}

export default StoreRequest
